import React, { createContext, useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const v = JSON.parse(localStorage.getItem("es_cart2")) || [];
      return v.filter((i) => typeof i.id === "string" && Number(i.qty) > 0 && typeof i.price === "number" && Number.isFinite(i.price)).map((i) => ({ ...i, qty: Math.round(Number(i.qty)) }));
    } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("es_cart2", JSON.stringify(items)); }, [items]);
  useEffect(() => {
    if (!items.length) return;
    api.get("/products").then(({ data }) => {
      const ok = new Set(data.map((p) => p.product_id));
      setItems((prev) => prev.filter((i) => ok.has(i.id)));
    }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const add = (p, qty = 1) => {
    if (p.price == null) { toast("Prezzo su richiesta: richiedi un preventivo"); return; }
    setItems((prev) => {
      const ex = prev.find((i) => i.id === p.product_id);
      if (ex) return prev.map((i) => (i.id === p.product_id ? { ...i, qty: i.qty + qty } : i));
      return [...prev, { id: p.product_id, name: p.name, price: p.price, img: p.img, qty }];
    });
    toast.success(`${p.name} aggiunto al carrello`);
  };
  const setQty = (id, qty) => setItems((prev) => (qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty } : i))));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.qty * i.price, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, total, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => React.useContext(CartContext);
